import axios from 'axios'

// Set config defaults when creating the instance
const httpClient = axios.create({
  //baseURL: 'http://localhost:3000/api'
  baseURL: process.env.VUE_APP_API_HOST + '/api',
  withCredentials: true,  //allow cookie
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': process.env.VUE_APP_API_HOST,
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE'
  }
});

httpClient.interceptors.response.use((response) => {
  return response.data;
}, function (error) {
  // Do something with response error
  if (error.response.status === 401) {
    console.log('unauthorized, logging out ...');
    //auth.logout();
    //router.replace('/auth/login');
  }
  var response = {
    status: error.response.status,
    statusText: error.response.status,
    error: error.response.data.error
  }
  return Promise.reject(response);
});

export default httpClient;